
































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {State} from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

@Component({
  components: {CompSelectBox}
})
export default class ItemTable extends Vue {
  @Prop() private option?: any;
  private initOver = false;
  private itemInfo = {
    haveRigthBtn: true,
    haveConfigBtn: true,
    havePageSizeBtn: true,
    haveExcelDownBtn: true,
    noBorder: false,
    onLoadSearch: false,
    excelDownInfo: null as any,
    pageSize: '100',
    pageSizes: [
      {
        value: '30',
        name: 'COMMON_PAGE_SIZE_30'
      },
      {
        value: '50',
        name: 'COMMON_PAGE_SIZE_50'
      },
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      }
    ]
  };

  @Prop({required: true})
  private gridProps!: any;
  @Prop({required: true})
  private data!: [];
  @Prop({required: true})
  private data1!: [];
  @Prop({default: 0})
  private totalCount!: number;
  @Prop({default: 0})
  private bodyheight!: number;

  @State private onGnb!: boolean;
  @Watch('onGnb')
  onGnbChanged() {
    (this.$refs.tuiGrid as Grid).invoke('refreshLayout');
    (this.$refs.tuiGrid1 as Grid).invoke('refreshLayout');
  }

  private changePageSize(value: any) {
    this.$emit('resetData', 1, Number(value));
  }

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    const grid1 = this.$refs.tuiGrid1 as Grid;
    const pagination = grid.invoke('getPagination') as any;

    if (this.bodyheight > 0) {
      if (this.gridProps.isShown == true && this.gridProps.isShown1 == true) {
        grid.invoke('setBodyHeight', 33);
        grid1.invoke('setBodyHeight', this.bodyheight);
      } else if (this.gridProps.isShown == true && this.gridProps.isShown1 == false) {
        grid.invoke('setBodyHeight', this.bodyheight);
      } else {
        grid1.invoke('setBodyHeight', this.bodyheight);
      }
    } else {
      if (this.gridProps.isShown == true && this.gridProps.isShown1 == true) {
        grid.invoke('setBodyHeight', 33);
        grid1.invoke('setBodyHeight', this.data1.length === 0 ? 190 : 290);
      } else if (this.gridProps.isShown == true && this.gridProps.isShown1 == false) {
        grid.invoke('setBodyHeight', this.data.length === 0 ? 190 : 480);
      } else {
        grid1.invoke('setBodyHeight', this.data1.length === 0 ? 190 : 480);
      }
    }

    if (pagination) {
      const pageState = {
        totalCount: this.totalCount,
        page: this.gridProps.options.pageOptions.page,
        perPage: this.gridProps.options.pageOptions.perPage
      };
      if (this.gridProps.isShown == true && this.gridProps.isShown1 == true) {
        grid.invoke('resetData', this.data as any, {pageState});
        grid1.invoke('resetData', this.data1 as any, {pageState});
      } else if (this.gridProps.isShown == true && this.gridProps.isShown1 == false) {
        grid.invoke('resetData', this.data as any, {pageState});
      } else {
        grid1.invoke('resetData', this.data1 as any, {pageState});
      }
    } else {
      if (this.gridProps.isShown == true && this.gridProps.isShown1 == true) {
        grid.invoke('resetData', this.data as any);
        grid1.invoke('resetData', this.data1 as any);
      } else if (this.gridProps.isShown == true && this.gridProps.isShown1 == false) {
        grid.invoke('resetData', this.data as any);
      } else {
        grid.invoke('resetData', this.data1 as any);
      }
    }
    this.$nextTick(() => {
      if (this.gridProps.isShown == true && this.gridProps.isShown1 == true) {
        grid.invoke('refreshLayout');
        grid1.invoke('refreshLayout');
      } else if (this.gridProps.isShown == true && this.gridProps.isShown1 == false) {
        grid.invoke('refreshLayout');
      } else {
        grid1.invoke('refreshLayout');
      }
    });
  }

  private getCheckedRowKeys() {
    return (this.$refs.tuiGrid as Grid).invoke('getCheckedRowKeys');
  }

  private getCheckedItems(propName: string) {
    const grid = this.gridProps.isShown === true ? (this.$refs.tuiGrid as Grid) : (this.$refs.tuiGrid1 as Grid);
    const items = grid.invoke('getCheckedRows').map(item => item[propName]);
    return items.join(',');
  }

  private initOption() {
    if (this.option) {
      if (this.option.haveRigthBtn !== undefined) {
        this.itemInfo.haveRigthBtn = this.option.haveRigthBtn;
      }
      if (this.option.haveConfigBtn !== undefined) {
        this.itemInfo.haveConfigBtn = this.option.haveConfigBtn;
      }
      if (this.option.havePageSizeBtn !== undefined) {
        this.itemInfo.havePageSizeBtn = this.option.havePageSizeBtn;
      }
      if (this.option.haveExcelDownBtn !== undefined) {
        this.itemInfo.haveExcelDownBtn = this.option.haveExcelDownBtn;
      }
      if (this.option.noBorder !== undefined) {
        this.itemInfo.noBorder = this.option.noBorder;
      }
      if (this.option.onLoadSearch !== undefined) {
        this.itemInfo.onLoadSearch = this.option.onLoadSearch;
      }
      if (this.option.excelDownInfo !== undefined) {
        this.itemInfo.excelDownInfo = this.option.excelDownInfo;
      }
      if (this.option.pageSize !== undefined) {
        this.itemInfo.pageSize = this.option.pageSize;
      }
      if (this.option.pageSizes !== undefined) {
        this.itemInfo.pageSizes = this.option.pageSizes;
      }
    }
    this.initOver = true;
  }

  private async mounted() {
    await this.initOption();
    const grid = this.$refs.tuiGrid as Grid;
    const grid1 = this.$refs.tuiGrid1 as Grid;
    const pagination = grid.invoke('getPagination');
    const pagination1 = grid1.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.$emit('resetData', ev.page);
        ev.stop();
      });
    }
    if (pagination1) {
      grid1.invoke('on', 'beforePageMove', (ev: any) => {
        this.$emit('resetData', ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
        if (ev.columnName === 'mergeMall') {
          $('th[data-column-name="totalMallDiscountAmt"]').removeClass('tui-grid-cell-selected');
          $('th[data-column-name="mallDiscountRate"]').removeClass('tui-grid-cell-selected');
        }
        if (ev.columnName === 'mergePartner') {
          $('th[data-column-name="totalPartnerDiscountAmt"]').removeClass('tui-grid-cell-selected');
          $('th[data-column-name="partnerDiscountRate"]').removeClass('tui-grid-cell-selected');
        }
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });

    grid1.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
        if (ev.columnName === 'mergeMall') {
          $('th[data-column-name="totalMallDiscountAmt"]').removeClass('tui-grid-cell-selected');
          $('th[data-column-name="mallDiscountRate"]').removeClass('tui-grid-cell-selected');
        }
        if (ev.columnName === 'mergePartner') {
          $('th[data-column-name="totalPartnerDiscountAmt"]').removeClass('tui-grid-cell-selected');
          $('th[data-column-name="partnerDiscountRate"]').removeClass('tui-grid-cell-selected');
        }
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });

    // if( this.gridProps.isShown == true &&  this.gridProps.isShown1 == true){
    //   this.$set(grid, ':header', 'gridProps.header');
    //   this.$set(grid1, ':header', 'gridProps.header')
    // }

    if (this.itemInfo.onLoadSearch) {
      this.$emit('resetData', 1);
    }
  }
}
